import api from "./api"
import { getStoredShipper } from "../../src/constants/utils"
const VISIBILITY_ROOT = "api"

const visibilityApi = {
    getShipmentListClient: function () {
        const { STORED_SHIPPER_NAME, STORED_RAILROAD_NAME } = getStoredShipper()

        var body = {
            Paging: {
                RecordsPerPage: 10000,
                PageRequested: 1,
            },
            Filter: {
                ExtractionId: 0,
                StationTracks: [],
                Railcars: [],
                EventCitiesStates: [],
            },
            Sort: { Field: 1, Order: 1 },

            ApiStandardParameters: {
                Road: STORED_RAILROAD_NAME,
                Shipper: STORED_SHIPPER_NAME,
            },
        }

        return api.post(
            `${VISIBILITY_ROOT}/ListShipments`,
            {
                ...body,
            },
            "STAGING"
        )
    },
    getShipperFilterValues() {
        const { STORED_SHIPPER_NAME, STORED_RAILROAD_NAME } = getStoredShipper()

        return api.post(
            `${VISIBILITY_ROOT}/ListShipments_FilterFieldsValues`,
            {
                ApiStandardParameters: {
                    Road: STORED_RAILROAD_NAME,
                    Shipper: STORED_SHIPPER_NAME,
                },
                Filter: {
                    ExtractionId: 0,
                    ShipmentTypes: [1, 2, 3, 4, 5],
                    StationTracks: [],
                },
            },
            "STAGING"
        )
    },
    getComments({ carId, waybillId }) {
        const { STORED_SHIPPER_NAME_ENCODED, STORED_RAILROAD_NAME_ENCODED } =
            getStoredShipper()

        return api.get(
            `userComments/${STORED_RAILROAD_NAME_ENCODED}/${STORED_SHIPPER_NAME_ENCODED}/${carId}/${waybillId}`,
            "ROOT"
        )
    },
    postComment({ roadId, shipperId, carId, waybillId, comments }) {
        return api.post(
            `userComments/`,
            {
                comments: [
                    {
                        comment: comments[0].comment,
                    },
                ],
                roadId: roadId,
                shipperId: shipperId,
                carId: carId,
                waybillId: waybillId,
            },
            "ROOT"
        )
    },

    getRejectReasons() {
        const { STORED_SHIPPER_NAME, STORED_RAILROAD_NAME } = getStoredShipper()

        return api.post(
            `${VISIBILITY_ROOT}/GetRejectReasonCodes`,
            {
                ApiStandardParameters: {
                    Road: STORED_RAILROAD_NAME,
                    Shipper: STORED_SHIPPER_NAME,
                },
            },
            "STAGING"
        )
    },

    saveActionCode(
        equipmentActionsList,
        submitDate,
        rejectReasonCode,
        emails,
        patternId
    ) {
        const { STORED_SHIPPER_NAME, STORED_RAILROAD_NAME } = getStoredShipper()

        let params = {
            ApiStandardParameters: {
                Road: STORED_RAILROAD_NAME,
                Shipper: STORED_SHIPPER_NAME,
            },
            EquipmentList: equipmentActionsList,
            SubmitDate: submitDate,
            ShipmentSource: 1,
            RejectReasonCode: rejectReasonCode,
            Pattern: patternId,
        }

        if (emails.length) params["NotificationEmailAddresses"] = [...emails]
        return api.post(
            `${VISIBILITY_ROOT}/SubmitActionCode`,
            params,
            "STAGING"
        )
    },

    GetWaybillInformation(details) {
        const { STORED_SHIPPER_NAME, STORED_RAILROAD_NAME } = getStoredShipper()

        return api.post(
            `${VISIBILITY_ROOT}/GetWaybillInformation`,
            {
                ApiStandardParameters: {
                    Road: STORED_RAILROAD_NAME,
                    Shipper: STORED_SHIPPER_NAME,
                },
                Railcar: details.equipId,
                ExtractionId: details.extractionID,
                WaybillControlNbr: details.waybillNumber,
            },
            "STAGING"
        )
    },

    GetRailcarMovements(details) {
        const { STORED_SHIPPER_NAME, STORED_RAILROAD_NAME } = getStoredShipper()

        return api.post(
            `${VISIBILITY_ROOT}/GetRailcarMovements`,
            {
                ApiStandardParameters: {
                    Road: STORED_RAILROAD_NAME,
                    Shipper: STORED_SHIPPER_NAME,
                },
                EquipInitial: details.equipInitial,
                EquipNumber: details.equipNumber,
                WaybillControlNumber: details.waybillNumber,
            },
            "STAGING"
        )
    },

    GetCarSchedulingRailcarMovements(details) {
        const { STORED_SHIPPER_NAME, STORED_RAILROAD_NAME } = getStoredShipper()

        return api.post(
            `${VISIBILITY_ROOT}/GetCarSchedulingRailcarMovements`,
            {
                ApiStandardParameters: {
                    Road: STORED_RAILROAD_NAME,
                    Shipper: STORED_SHIPPER_NAME,
                },
                Railcar: details.railcar,
                WaybillControlNumber: details.waybillNumber,
            },
            "STAGING"
        )
    },

    GetShipmentWaybill(details) {
        const { STORED_SHIPPER_NAME, STORED_RAILROAD_NAME } = getStoredShipper()

        return api.post(
            `${VISIBILITY_ROOT}/GetShipmentWaybill`,
            {
                ApiStandardParameters: {
                    Road: STORED_RAILROAD_NAME,
                    Shipper: STORED_SHIPPER_NAME,
                },
                Car: details.equipId,
                WaybillControlNumber: details.waybillNumber,
            },
            "STAGING"
        )
    },

    getEbolToken() {
        const { STORED_SHIPPER_NAME, STORED_RAILROAD_NAME } = getStoredShipper()

        return api.post(
            `${VISIBILITY_ROOT}/GetEBOLToken`,
            {
                ApiStandardParameters: {
                    Road: STORED_RAILROAD_NAME,
                    Shipper: STORED_SHIPPER_NAME,
                },
            },
            "STAGING"
        )
    },
    getCarsForResequence({ station, track }) {
        const { STORED_SHIPPER_NAME, STORED_RAILROAD_NAME } = getStoredShipper()

        return api.post(
            `${VISIBILITY_ROOT}/ListRailcarsOnTrackToResequence`,
            {
                ApiStandardParameters: {
                    Road: STORED_RAILROAD_NAME,
                    Shipper: STORED_SHIPPER_NAME,
                },
                Station: station,
                Track: track,
            },
            "STAGING"
        )
    },

    saveCarsForResequence({ station, track, cars }) {
        const { STORED_SHIPPER_NAME, STORED_RAILROAD_NAME } = getStoredShipper()

        return api.post(
            `${VISIBILITY_ROOT}/ResequenceTrack`,
            {
                ApiStandardParameters: {
                    Road: STORED_RAILROAD_NAME,
                    Shipper: STORED_SHIPPER_NAME,
                },
                Station: station,
                Track: track,
                Railcars: [...cars],
            },
            "STAGING"
        )
    },
}

export default visibilityApi
